import { RegistriaUserErrorResponse } from '../../models/registria/registria-user-error-response.interface';

export const mockRegistriaUserErrorResponse: RegistriaUserErrorResponse = {
  message: 'Error fetching snippet data but customer was created',
};
